import palette from 'Theme/palette'

const colors = {
  ...palette,

  transparent: 'transparent',

  primary: {
    main: palette.pictonBlue,
    dark: palette.cyanCornflowerBlue,
  },

  secondary: {
    main: palette.dollarBill,
    dark: palette.wageningenGreen,
    contrast: palette.white,
  },

  error: {
    main: palette.carminePink,
    dark: palette.fireEngineRed,
  },

  success: {
    contrast: palette.white,
  },

  background: {
    panel: `${palette.white}e6`,
    paperElevation0: palette.lavenderGray,
    paperElevation2: palette.brightGray,
    paperElevation24: palette.white,

    screen: palette.white,
    screenAlt: palette.cultured,
    screenContrast: palette.outerSpaceCrayola,
    screenAccent: palette.antiFlashWhiteAlt,
    screenAccentAlt: palette.culturedAlt,

    badge: palette.bubbles,
  },

  text: {
    disabled: `${palette.outerSpaceCrayola}73`,
    primary: palette.outerSpaceCrayola,
    secondary: `${palette.outerSpaceCrayola}bf`,

    important: palette.vampireBlack,
    body: palette.blackOlive,
    inverse: palette.white,
    success: palette.dollarBill,
  },

  line: {
    primary: palette.lightSilver,
    secondary: palette.antiFlashWhite,
    tertiary: palette.gainsboro,
    quaternary: palette.outerSpaceCrayola,
  },

  border: {
    link: palette.brightGrayAlt,
  },

  overlay: {
    default: `${palette.black}44`,
    image: `${palette.black}33`,
    deep: `${palette.black}aa`,
    primary: `${palette.pictonBlue}aa`,
    primaryDeep: `${palette.pictonBlue}dd`,
    primaryAlt: `${palette.pictonBlue}77`,
    primaryAlt2: `${palette.richBlack}b2`,
  },
}

export default colors
